import { KANNADA } from '../../../assets/images';
import { Section, TableOfContent } from '../../../typings/interfaces';
// Kannada
const KNSection: Section[] = [
  {
    name: '1: ಉಲ್ಲೇಖ ಮತ್ತು ಅವಲೋ ಕನ',
    subSections: [
      {
        name: 'ಮುನ್ನಡಿ',
        page: 3,
      },
      {
        name: 'ಉದ್ದೇಶ ಮತ್ತು ಕ್ಷೇತ್ರ ಮಾರ್ಗದರ್ಶಿ ಅಪ್ಲಿಕೇಶನ್ಗಳು',
        page: 4,
      },
      {
        name: 'ಪ್ರಮುಖ ವ್ಯಾಖ್ಯಾನಗಳು',
        page: 5,
      },
      {
        name: 'ನಿಯಂತ್ರಣಗಳ ಶ್ರೇಣ',
        page: 6,
      },
    ],
  },
  {
    name: '2: ಜೀವ ರಕ್ಷಕಗಳು',
    subSections: [
      {
        name: 'ಮೋಟಾರು ವಾಹನ – ಟ್ರಾಫಿಕ್ ಸುರಕ್ಷತೆ',
        page: 9,
      },
      {
        name: 'ಎತ್ತರದಲ್ಲಿ ಕೆಲಸ ಮಾಡುವುದು',
        page: 12,
      },
      {
        name: 'ಚಲಿಸುವ ಉಪಕರಣ (ಎಂಪಿಇ)',
        page: 18,
      },
      {
        name: 'ಲಾಕ್ಔಟ್ ಟ್ಯಾಗ್ಔಟ್ / ಎನರ್ಜಿ ಐಸೊಲ ೇಶನ',
        page: 22,
      },
      {
        name: 'ವಿದ್ಯುತ್ ಕೆಲಸ',
        page: 25,
      },
      {
        name: 'ಇಕ್ಕಟ್ಟಾದ ಸ್ಥಳ',
        page: 29,
      },
      {
        name: 'ಭಾರೀ ಗಾತ್ರದ ವಸ್ತು ಮತ್ತು ಸಂಗ್ರಹಣೆ',
        page: 32,
      },
      {
        name: 'ರ ೈಲ್ಕಾರ್ ಸುರಕ್ಷತ',
        page: 37,
      },
      {
        name: 'ಅಗೆಯುವುದು ಮತ್ತು ಕಂದಕದ ಕೆಲಸ',
        page: 41,
      },
      {
        name: 'ಎತ್ತುವುದು & ಸಜ್ಜುಗೊಳಿಸುವುದು',
        page: 45,
      },
      {
        name: 'ಆಪತ್ತುಕಾರಕ ವಸ್ತುಗಳು',
        page: 49,
      },
      {
        name: 'ಬಿಸಿ ಕೆಲಸ',
        page: 52,
      },
    ],
  },
  {
    name: '3: ಹೆಚ್ಚುವರ ಸಂಪನ್ಮೂಲಗಳು ಮತ್ತು ಸಾಧನಗಳು',
    subSections: [
      {
        name: 'ನೀರಿನ ಮೇಲೆ ಮತ್ತು ಸುತ್ತಮುತ್ತ ಕೆಲಸ ಮಾಡುವುದು',
        page: 56,
      },
      {
        name: 'ಬಿದ್ದಿರುವ ಅಥವಾ ಬೀಳುತ್ತಿರುವ ವಸ್ತುಗಳು',
        page: 59,
      },
      {
        name: 'ವಾತಾವರಣ/ಅನಿಲ ಪರೀಕ',
        page: 61,
      },
      {
        name: 'ರಾಸಾಯನಿಕದ ಆಪತ್ತಿನ ಸಂವಹನ',
        page: 65,
      },
    ],
  },
  {
    name: '4: Cargill ಸುರಕ್ಷತಾ ನಿರ್ವಹಣೆಯ ರೂಢಿಗಳು',
    subSections: [
      {
        name: 'ಮುಖ್ಯ ಶಬ್ದಗಳು',
        page: 70,
      },
      {
        name: 'ಘಟನೆಯ ತೀವ್ರ ಗಾಯ ಮತ್ತು ಜೀವಹಾನಿ(ಎಸ್ಐಎಫ್) ನಿರ್ಧಾರ',
        page: 72,
      },
      {
        name: 'ತೀವ್ರ ಗಾಯ ಮತ್ತು ಜೀವಹಾನಿಯ ಸಾಧ್ಯತೆ(ಎಸ್ಐಎಫ್ಪಿ) ವರ್ಗೀಕರಣ',
        page: 73,
      },
      {
        name: 'ಎಸ್ಐಎಫ್ ಸ್ವಯಂಚಾಲಿತನಿರ್ಧರಣೆ ಮಾನದಂಡ ಕ ೋ ಷ್ಠಕ',
        page: 74,
      },
      {
        name: 'ಮಾನವ ಮತ್ತು ಸಾಂಸ್ಥಿಕ ಕಾರ್ಯಕ್ಷಮತೆ(ಎಚ್ಒಪಿ)',
        page: 76,
      },
    ],
  },
];
const KNTableofContent: TableOfContent = {
  language: 'kn',
  sections: KNSection,
  label: 'ಪರಿವಿಡಿ',
  pdfLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/Cargill Field Safety Guide (kn_IN)_DIGITAL_CROPPED.pdf',
  hopPocket: 'HOP ಪಾಕೆಟ್ ಗೈಡ್',
  hopPocketLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/HOP pocket guide content 2021-09-08_Kannada.pdf',
  source: KANNADA,
};

export default KNTableofContent;
